<script>

import axios from 'axios'
import * as d3 from 'd3'
import * as topojson from 'topojson'


export default {
    props:{
      source: {
        type: String,
        default: ''
      },
    },
    inject: ['getWidth'],
    data() {
      return {
        csv: null,
        projection: null,
        borders: null,
        countries: [],
        countryRisk: [],
        countryInfo: [],
        offsetX: 50,
        offsetY: 0,
        avgRiskAcc: 0,
        avgRiskCnt: 0,
        viewbox: "0 0 0 0",
        modalRiskDetailShow:'',
        timer: '',
        settings: {
            strokeColor: "#19B5FF",
            width: 570,
            height: 320
        },
        trendLineMessage: "",
        datasetMaxSize: 40,
        dataset: {
          values: [0, 0],
          labels: ['', '']
        },
  			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      }
    },
    computed: {
      transTriangleTrend() {
        return `translate(${this.settings.width-60}, ${this.riskTrendPosY()})`;
      }
    },
    created: function() {
      let that = this;
      const refresh = 10000;
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios
        .get(`${baseURL}${that.source}`)
        .then(function (response) {
          if (response.status !== 200) 
          {
            console.log("GeoRisk Error - HTTP Error loading Process Risk definition file. Status: " + response.status);
            return
          }
          if (response.data.length === 0) {
            console.log("GeoRisk Error - Process Risk definition file empty.");
            return
          } 
          response.data.map(function(country) {
            country.risk = null;
            country.risk_class = "normal";
            that.countryRisk.push(country);
          });
        })
        .catch(function (error) {
            console.log('error:', error.response);
        }) 
      // this.timer = setInterval(this.geoRisk, refresh);
      that.geoRisk()
    },
    watch: {
  
    },
    methods: {
      geoRisk: function() {
        let that = this;

        that.countries.map(function(country) { 
          country.risk_class = "normal";
          let countryInfo = that.resolveCountryInfoById(country.id);
          if (that.countryRisk === undefined || countryInfo == undefined) {
            return
          }

          that.countryRisk.map(function(crisk) {
            if (crisk.country_code === countryInfo.codalfa2) {
              country.risk_class = "neutral";
            }
          })
        })
      },
      pathGenerator: function(argu) {
          var pgfunc = d3.geoPath().
              projection(this.projection);
          return pgfunc(argu);
      },
      resolveCountryInfoById: function(id) {
          var result;
          this.countryInfo.map(function(country){
              if (country.id == id) { 
                  result = country;
              }
          });
          return result;
      },
      calculatePath: function() {
        let that = this
        that.projection = d3.geoMercator()
            .scale(that.settings.width / 2 / Math.PI)
            .scale(100)
            .translate([(that.settings.width / 2) + that.offsetX, (that.settings.height / 2) + that.offsetY])

        d3.json("https://360secpublic.s3.amazonaws.com/topo/world-110m.json").then(function(world) {
          var countries = topojson.feature(world, world.objects.countries).features;
          that.borders = topojson.mesh(world, world.objects.countries, function(a, b) { return a.id !== b.id; });
          countries.map(function(country) {
            country.risk = 0;
            country.risk_class = "normal";
            country.name = "";
            country.code = "";
            that.countries.push(country);
          });
        })

        d3.tsv("https://360secpublic.s3.amazonaws.com/topo/paises.tsv").then(function(countries) {
          countries.map(function(country) {
            that.countryInfo.push(country);
          });          
        })
      },
      countryNameClickHandlerMap(name, code) {

      },
      resizeMap: function() {
        this.settings.width = this.getWidth() - 24
        this.settings.height = 320
      },
      handleResize: function(event) { 
        this.resizeMap();
      },
      cancelAutoUpdate: function() { 
          clearInterval(this.timer) 
      }
    },
    mounted () {
        let that = this

        that.$nextTick(() => {
          that.calculatePath();
          that.resizeMap();
          setInterval(this.geoRisk, 1000);
        })
      },
    beforeMount: function () {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function() {
        clearInterval(this.timer);
    }
  }
  </script>

  <template>
    <svg v-bind:width="settings.width" v-bind:height="settings.height" class="svg-map">
      <g class="countries" v-for="(country, index) in countries" v-bind:key="index">
          <path :d="pathGenerator(country)" 
          :class="country.risk_class" 
          @click="countryNameClickHandlerMap(country.name, country.code)" />
      </g>
    </svg>
</template>


<style>
  .svg-map {
    /* background: lightBlue; */
      background: #F6F9FA;

  }

  .countries {
  
    stroke: white;
    stroke-width: 0.2px;

    fill: #D7DBE2;
  }


  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }
  
  .neutral {
    color: #03A3FF;
    fill: #03A3FF;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .high {
    color: #DC001E;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;  
  }

  .medium {
    color: #FECA00;
    fill: #FECA00;
    background-color: #FECA00 !important;
    border: 0px !important;  
  }

  .low {
    color: #01AD00;
    fill: #01AD00;
    background-color: #01AD00 !important;
    border: 0px !important;  
  }
</style>
